import { NumberInput as ChakraNumberInput } from '@chakra-ui/react';
import { forwardRef } from 'react';

export interface NumberInputRootProps extends ChakraNumberInput.RootProps {
  formatOptions?: Intl.NumberFormatOptions;
}

export const NumberInputRoot = forwardRef<HTMLDivElement, NumberInputRootProps>(
  function NumberInputRoot(props, ref) {
    const { formatOptions, ...rest } = props;
    return (
      <ChakraNumberInput.Root ref={ref} variant="outline" {...rest} formatOptions={formatOptions} />
    );
  }
);

export const NumberInputField = ChakraNumberInput.Input;
export const NumberInputControl = ChakraNumberInput.Control;
export const NumberInputIncrementTrigger = ChakraNumberInput.IncrementTrigger;
export const NumberInputDecrementTrigger = ChakraNumberInput.DecrementTrigger;
export const NumberInputScrubber = ChakraNumberInput.Scrubber;
export const NumberInputLabel = ChakraNumberInput.Label;
